import React, { useEffect, useState, useContext } from "react";

import CardContainer from "../../../components/Card";
import TableContainer from "../../../components/Table";
import StaffDeliverySidebar from "./StaffDeliverySidebar";
import { StoreContext } from "../../../context";
import { opsApiCall, getOpsToken } from "../../../helpers/rapsapOpsAuth";

const mainColumns = [
  {
    title: "Staff Name",
    dataIndex: "staff_name",
    key: "staff_name",
    sorter: true,
  },
  {
    title: "Username",
    dataIndex: "username",
    key: "username",
  },
  {
    title: "Mobile",
    dataIndex: "staff_mobile",
    key: "staff_mobile",
    render: (text) => text || "-",
  },
  {
    title: "Total Orders",
    dataIndex: "total_orders_delivered",
    key: "total_orders_delivered",
    align: "center",
    sorter: true,
  },
  {
    title: "COD Orders",
    dataIndex: "total_cod_orders",
    key: "total_cod_orders",
    align: "center",
    sorter: true,
  },
  {
    title: "Prepaid Orders",
    dataIndex: "total_prepaid_orders",
    key: "total_prepaid_orders",
    align: "center",
    sorter: true,
  },
  {
    title: "Total Amount",
    dataIndex: "total_amount_collected",
    key: "total_amount_collected",
    render: (text) => (
      <div style={{ textAlign: "right" }}>₹ {text ? text : 0}</div>
    ),
    sorter: true,
  },
  {
    title: "Today's Collection",
    dataIndex: "amount_collected_today",
    key: "amount_collected_today",
    render: (text) => (
      <div style={{ textAlign: "right" }}>₹ {text ? text : 0}</div>
    ),
    sorter: true,
  },
  {
    title: "Joined Date",
    dataIndex: "joined_date",
    key: "joined_date",
    align: "center",
  },
];

const storeColumns = [
  {
    title: "Staff Name",
    dataIndex: "staff_name",
    key: "staff_name",
    sorter: true,
  },
  {
    title: "Username",
    dataIndex: "username",
    key: "username",
  },
  {
    title: "Mobile",
    dataIndex: "staff_mobile",
    key: "staff_mobile",
    render: (text) => text || "-",
  },
  {
    title: "Total Orders",
    dataIndex: "total_orders_delivered",
    key: "total_orders_delivered",
    align: "center",
    sorter: true,
  },
  {
    title: "COD Orders",
    dataIndex: "total_cod_orders",
    key: "total_cod_orders",
    align: "center",
    sorter: true,
  },
  {
    title: "Prepaid Orders",
    dataIndex: "total_prepaid_orders",
    key: "total_prepaid_orders",
    align: "center",
    sorter: true,
  },
  {
    title: "Total Amount",
    dataIndex: "total_amount_collected",
    key: "total_amount_collected",
    render: (text) => (
      <div style={{ textAlign: "right" }}>₹ {text ? text : 0}</div>
    ),
    sorter: true,
  },
  {
    title: "Today's Collection",
    dataIndex: "amount_collected_today",
    key: "amount_collected_today",
    render: (text) => (
      <div style={{ textAlign: "right" }}>₹ {text ? text : 0}</div>
    ),
    sorter: true,
  },
  {
    title: "Joined Date",
    dataIndex: "joined_date",
    key: "joined_date",
    align: "center",
  },
];

export default function DeliveryPayments() {
  const { storeId } = useContext(StoreContext);
  const [loading, setLoading] = useState(false);
  const [savedPayload, setSavedPayload] = useState({});
  const [total, setTotal] = useState(0);
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState({});
  const [sidebar, setSidebar] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    initializeAuth();
  }, [storeId]);

  const initializeAuth = async () => {
    try {
      setLoading(true);
      setError(null);
      const token = await getOpsToken();
      if (token) {
        await getList(savedPayload);
      } else {
        throw new Error("Failed to authenticate");
      }
    } catch (error) {
      console.error("Error initializing delivery payments auth:", error);
      setError("Failed to initialize authentication. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getList = async (payload = {}) => {
    setLoading(true);
    if (storeId) payload = { ...payload, store_id: storeId };
    else delete payload.store_id;
    const res = await opsApiCall("/rapid/getDeliveryStaffSummary", payload);
    if (Array.isArray(res?.data)) {
      setList(res.data);
      setTotal(res.meta?.total);
    }
    setSavedPayload(payload);
    setLoading(false);
  };

  return (
    <>
      <StaffDeliverySidebar
        visible={sidebar}
        onClose={() => {
          console.log('Closing staff delivery sidebar');
          setSidebar(false);
        }}
        data={selected}
      />
      <CardContainer hoverable={false}>
        <TableContainer
          breadcrumbTitle="Delivery Staff Payments"
          loading={loading}
          columns={storeId ? storeColumns : mainColumns}
          data={list}
          total={total}
          searchFor="Staff Name, Username"
          rowClickHandler={(record) => {
            setSelected(record);
            setSidebar(true);
          }}
          functionsHandler={getList}
        />
      </CardContainer>
    </>
  );
}
